// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import Details from '@Molecules/Details/Details';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import React, { ReactElement } from 'react';
import { TaxonomyOutput } from 'thehive-sdk';
import { extractData } from '@Organisms/Taxonomy//extractData';
import { THButton } from '@Molecules/Inputs/THButton/THButton';

import './TaxonomyPreview.scss';

interface TaxonomyPreviewProps {
    taxonomy: TaxonomyOutput;
}

const TaxonomyPreview = ({ taxonomy }: TaxonomyPreviewProps): ReactElement => {
    const locale = useLocalMessage();

    const { namespace } = taxonomy;

    const extract = extractData({ locale });

    return (
        <THDrawer
            title={`${namespace} ${locale('taxonomy.preview.title')}`}
            triggerElem={<THButton type="link">{namespace}</THButton>}
            width="85vw"
        >
            <Details data={taxonomy} extract={extract} />
        </THDrawer>
    );
};

export default TaxonomyPreview;
